import React from 'react';
import { match } from 'ts-pattern';

import dt from '~/testing';
import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';
import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

import ReviveEntryScreen from './ReviveEntryScreen';
import ReviveEntrySubmittingScreen from './ReviveEntrySubmittingScreen';
import useReviveEntryModal from './useReviveEntryModal';
import useStyles from './ReviveEntryModal.styles';
import ReviveEntryLoadingScreen from './ReviveEntryLoadingScreen';

type ReviveEntryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  entryId: string;
  entryName: string;
  contestId: string;
  contest: FullContest;
};

function ReviveEntryModal({
  isOpen,
  onClose,
  entryId,
  entryName,
  contestId,
  contest,
}: ReviveEntryModalProps) {
  const { classes } = useStyles();

  const {
    state,
    handleRevive,
    handleDepositClick,
    balanceInDollars,
    revivalsAvailable,
    isCreateEntriesReady,
    isBalanceLoading,
  } = useReviveEntryModal({
    contestId,
    entryId,
    entryName,
    contest,
    onClose,
  });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      dataTestId={dt.contest.gamecenter.teamSurvivor.reviveEntryModal}
    >
      <DialogBody className={classes.body}>
        <div className={classes.content}>
          {match(state)
            .with('loading', () => <ReviveEntryLoadingScreen />)
            .with('success', () => <ReviveEntrySubmittingScreen />)
            .with('submitting', () => <ReviveEntrySubmittingScreen />)
            .otherwise(() => (
              <ReviveEntryScreen
                onRevive={handleRevive}
                onCancel={onClose}
                onDepositClick={handleDepositClick}
                entryName={entryName}
                balanceInDollars={balanceInDollars}
                contest={contest}
                revivalsAvailable={revivalsAvailable}
                isCreateEntriesReady={isCreateEntriesReady}
                isBalanceLoading={isBalanceLoading}
              />
            ))}
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default ReviveEntryModal;
